import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common'
@Pipe({
  name: 'datefilter'
})
export class DatefilterPipe implements PipeTransform {
constructor(public datepipe: DatePipe){}

  transform(items: any[], field: Date, value: Date): any {
    if (!items) {
      return [];
    }
    else if (!field || !value) {
        return items;
    }
    else {
      return items.filter(singleItem => {
        if(field.getDate()==value.getDate() && field.getMonth()==value.getMonth() && field.getFullYear()==value.getFullYear() ){
          return singleItem;
        }
      });
    } 
  }

}
